import { DriverDto, LogbookRecordViolation, LogbookRecordWarning } from '@fleet-beat/api';
import { LogRecordStatus } from '@fleet-beat/core';

export interface LogsModel {
  [k: string]: any;
  driverId?: string;
  driver?: DriverDto;
  onlineStatus?: boolean;
  isDeviceConnected?: boolean;
  truckNo?: string;
  vehicleID?: string;
  status?: `${LogRecordStatus}`;
  drive?: number;
  break?: number;
  shift?: number;
  cycle?: number;
  recap?: number;
  violations?: number;
  warnings?: number;
  lastSync?: string;
  warningsList?: LogbookRecordWarning[];
  violationsList?: LogbookRecordViolation[];
}
